import React, { useEffect } from "react";
import CustomButton from "../../../../components/custom/CustomButton";
import {
  Layout,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Select,
  Form,
  DatePicker,
} from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
const { Content } = Layout;
const { Text } = Typography;

const BranchForm = ({
  parentBranch = [],
  onSubmit,
  tableData = [],

  session,
  setIsLoading,
  cnt,
  apiConfig,
  BOM,
}) => {
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const currentYear = dayjs().year();

  // Disable future dates and restrict to current year only
  const disabledDate = (current) => {
    return current.year() !== currentYear || current > dayjs().endOf("day");
  };

  // Set default values on mount
  useEffect(() => {
    if (parentBranch.length > 0) {
      form.setFieldsValue({
        openedOn: dayjs(), // today
        parentBranch: parentBranch[0].value, // first option's ID
      });
    }
  }, [parentBranch]);

  const handleSubmit = (values) => {
    const payload = {
      parentId: values.parentBranch,
      name: values.name,
      externalId: values.externalId || "",
      openingDate: values.openedOn
        ? dayjs(values.openedOn).format("DD MMMM YYYY")
        : null,
    };

    console.log("Payload:", payload);

    const body = {
      ...payload,
      method: "POST",
      session,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.Office, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Branch Created Successfully");
        // setIsModalVisible(true);
        navigate("/sya0200");
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const onCancel = () => {
    navigate("/sya0200", { replace: false });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      style={{ paddingTop: 20 }}
      onFinish={handleSubmit}
    >
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Card
          style={{
            marginBottom: "2%",
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          }}
        >
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <Form.Item
                name="name"
                label={<Text strong>Office</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Input
                  placeholder="Enter office name"
                  style={{ width: "30vh" }}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="parentBranch"
                label={<Text strong>Parent Branch</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Select
                  placeholder="Select a parent branch"
                  style={{ width: "30vh" }}
                  options={parentBranch}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="openedOn"
                label={<Text strong>Opened On</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <DatePicker
                  style={{ width: "30vh" }}
                  disabledDate={disabledDate}
                  format="DD MMMM YYYY"
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="externalId"
                label={<Text strong>External ID</Text>}
              >
                <Input
                  placeholder="Enter external ID"
                  style={{ width: "30vh" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Form.Item>
          <Row>
            <CustomButton
              content="Submit"
              htmlType="submit"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#92428B"
              colorText="white"
              hoverBackground="#AD4EA7"
            />
            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={onCancel}
            />
          </Row>
        </Form.Item>
      </Card>
    </Form>
  );
};

export default BranchForm;
